//
//
//
//
//
//

import { mapGetters } from 'vuex';
import DynamicLandingPage from '@/components/landing/DynamicLandingPage.vue';
import { getDynamicPage } from '@/api/dlp.js';
import { listFolderItems } from '@motionelements/core/src/api/folders.js';
import seoRedirectMixin from '@/components/mixins/seo-redirect.mixin.js';

export default {
  name: 'dlp-page',
  mixins: [seoRedirectMixin],
  components: {
    DynamicLandingPage,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      dlpData: 'dlp/dlpData',
      backgroundImageUrl: 'dlp/backgroundImageUrl',
      keywords: 'dlp/keywords',
      heading: 'dlp/heading',
      subheading: 'dlp/subheading',
      description: 'dlp/description',
      lightboxes: 'dlp/lightboxes',
      mediaTypes: 'dlp/mediaTypes',
      dynamicElementsByMediaType: 'dlp/dynamicElementsByMediaType',
    }),
    mediaType() {
      return this.mediaTypes && this.mediaTypes[0];
    },
  },
  async fetch() {
    const page = parseInt(this.$route.query.page || 1, 10);
    const id = this.id.substring(1);
    try {
      const response = await getDynamicPage(id, { perPage: 96, page });
      const data = response.data.data;
      this.isLoaded = true;
      this.handleSeoRedirect(_.get(data, 'url'));
      this.$store.commit('dlp/setDlpData', data);
      if (data.backgroundImage) {
        this.$store.commit('dlp/setBackgroundImageUrl', _.get(data, 'backgroundImage.url'));
      }
      // Pre-fetch first lightbox items on SSR for SEO (element links and names in HTML)
      const firstLightbox = _.get(data, 'lightboxes[0]');
      if (firstLightbox && firstLightbox.id) {
        try {
          const { data: { data: elements, totalCount } } = await listFolderItems(firstLightbox.id, {
            page: 1,
            per_page: 12,
            published: true,
          });
          this.$store.commit('dlp/setSsrLightboxElements', {
            lightboxId: firstLightbox.id,
            elements: elements || [],
            totalCount: totalCount || 0,
          });
        } catch (lightboxErr) {
          // Non-critical: silently skip if lightbox items fail to load
        }
      }
      // Dynamic sections (More Stock photo, etc.) load on demand when user clicks sidebar links
    } catch (err) {
      const statusCode = _.get(err, 'response.status', 500);
      const message = _.get(err, 'response.data.message', err.message) || 'Failed to load page';
      this.$nuxt.context.error({ statusCode, message });
    }
  },
  fetchOnServer: true,
};
